import React from 'react';
import { divider, primary } from '../Styles/Colours';
import styles from './FinalisingPharmacyRequest.module.css';
import Pharmacist from '../Images/pharmacist.svg';
import { withStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
var ColorLinearProgress = withStyles({
    colorPrimary: {
        backgroundColor: divider
    },
    barColorPrimary: {
        backgroundColor: primary
    }
})(LinearProgress);
export var FinalisingPharmacyRequest = function (props) {
    var _a, _b, _c, _d;
    return (React.createElement("div", { className: styles.body },
        React.createElement("img", { src: Pharmacist, alt: '', className: styles.main }),
        React.createElement("div", { className: styles.title },
            "Finalising your ",
            React.createElement("em", null, (_b = (_a = props.pharmacyRequestTerm) === null || _a === void 0 ? void 0 : _a.singularTerm) === null || _b === void 0 ? void 0 : _b.toLowerCase())),
        React.createElement("div", { className: styles.info },
            "We're preparing your ", (_d = (_c = props.pharmacyRequestTerm) === null || _c === void 0 ? void 0 : _c.singularTerm) === null || _d === void 0 ? void 0 :
            _d.toLowerCase(),
            "..."),
        React.createElement(ColorLinearProgress, { className: styles.progress })));
};
